import { useMutation, useQueryClient } from "@tanstack/react-query";

import deleteUsersById from "../api/deleteUsersById";

const useDeleteUsersById = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userIds: number[]) => deleteUsersById(userIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getAllUsers"],
      });
      queryClient.invalidateQueries({
        queryKey: ["getUsersByName"],
      });
    },
  });
};

export default useDeleteUsersById;
